import { render, staticRenderFns } from "./panel-grid.vue?vue&type=template&id=67a59966&scoped=true&"
import script from "./panel-grid.vue?vue&type=script&lang=ts&"
export * from "./panel-grid.vue?vue&type=script&lang=ts&"
import style0 from "./panel-grid.vue?vue&type=style&index=0&id=67a59966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a59966",
  null
  
)

export default component.exports